<div class="py-4 container-fluid subject-management-page">
  <h4 class="mb-4 subject-management-title">การจัดการรายวิชา</h4>

  <div class="subject-management-card">
    <div class="subject-management-card-body">
      <div class="subject-management-toolbar" [formGroup]="form">
        <div class="subject-management-filters">
          <div class="subject-management-filter">
            <app-select
              label="เทอมการศึกษา"
              formControlName="academicTerm"
              [options]="academicTermOptions"
              [searchable]="false"
              [clearable]="true"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="subject-management-filter">
            <app-select
              label="ปีการศึกษา"
              formControlName="year"
              [options]="yearOptions"
              [searchable]="false"
              [clearable]="true"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>
           <div class="subject-management-filter">
            <app-select
              label="ประเภทรายวิชา"
              formControlName="subjectType"
              [options]="subjectTypeOptions"
              bindLabel="label"
              bindValue="id"
              [searchable]="false"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>

          <div class="subject-management-search-filter">
            <app-filter-search-input
              label="รหัสวิชา, ชื่อรายวิชา"
              formControlName="keyword"
              inputClass="subject-management-search-input"
              classes="mb-0"
              ariaLabel="ค้นหารายวิชา"
              (searchSubmit)="onSearch()"
            ></app-filter-search-input>
          </div>

          <div class="subject-management-filter">
            <app-select
              label="หลักสูตร"
              formControlName="curriculumType"
              [options]="curriculumOptions"
              bindLabel="label"
              bindValue="id"
              [searchable]="true"
              inputClass="subject-management-select"
              classes="mb-0"
            ></app-select>
          </div>
        </div>
      </div>

      <div class="subject-management-tab-row">
        <div class="subject-management-tabs" role="tablist" aria-label="ตัวกรองสถานะรายวิชา">
          <button
            type="button"
            class="subject-management-tab"
            [class.active]="selectedTab === 'all'"
            (click)="onTabChange('all')"
          >
            รายการทั้งหมด
          </button>
          <button
            type="button"
            class="subject-management-tab"
            [class.active]="selectedTab === 'special_revision_requested'"
            (click)="onTabChange('special_revision_requested')"
          >
            ส่งกลับแก้ไขพิเศษ
          </button>
          <button
            type="button"
            class="subject-management-tab"
            [class.active]="selectedTab === 'revision_requested'"
            (click)="onTabChange('revision_requested')"
          >
            ส่งกลับแก้ไข
          </button>
          <button
            type="button"
            class="subject-management-tab"
            [class.active]="selectedTab === 'ready_for_teacher'"
            (click)="onTabChange('ready_for_teacher')"
          >
            รอดำเนินการ
          </button>
          <button
            type="button"
            class="subject-management-tab"
            [class.active]="selectedTab === 'teacher_confirmed'"
            (click)="onTabChange('teacher_confirmed')"
          >
            รอพิจารณารับรอง
          </button>
          <button
            type="button"
            class="subject-management-tab"
            [class.active]="selectedTab === 'imported_pending_fix'"
            (click)="onTabChange('imported_pending_fix')"
          >
            แบบร่าง
          </button>
          <button
            type="button"
            class="subject-management-tab"
            [class.active]="selectedTab === 'approved'"
            (click)="onTabChange('approved')"
          >
            รับรองแล้ว
          </button>
        </div>

        @if (!isSubjectManagementViewOnly) {
          <div class="subject-management-buttons">
            <button
              type="button"
              class="btn subject-management-add-button"
              [disabled]="!isSelectedTermSynced"
              (click)="onAddSubject()"
            >
              <img src="assets/media/icons/svg/add-item.svg" class="subject-management-toolbar-icon" alt="" aria-hidden="true" />
              <span>เพิ่มรายวิชา</span>
            </button>
          </div>
        }
      </div>

      <ng-template #manualStatusTemplate let-row="row">
        <span class="subject-management-manual-status-cell">
          @if (row.isSynced === false) {
          <img
            src="assets/media/icons/svg/user-create.svg"
            class="subject-management-manual-status-icon"
            alt=""
            aria-hidden="true"
          />
          }
        </span>
      </ng-template>

      <ng-template #rowIndexTemplate let-row="row">
        {{ row.sequence ?? '-' }}
      </ng-template>

      <ng-template #statusTemplate let-row="row">
        <span
          class="subject-management-status-badge"
          [class.subject-management-status-badge-progress]="row.status === 'in_progress'"
          [class.subject-management-status-badge-pending]="row.status === 'pending'"
          [class.subject-management-status-badge-pending-approval]="row.status === 'pending_approval'"
          [class.subject-management-status-badge-special-sent-back]="row.status === 'special_sent_back'"
          [class.subject-management-status-badge-sent-back]="row.status === 'sent_back'"
          [class.subject-management-status-badge-completed]="row.status === 'completed'"
          [class.subject-management-status-badge-draft]="row.status === 'draft'"
        >
          {{ row.statusLabel }}
        </span>
      </ng-template>

      <ng-template #actionTemplate let-row="row">
        <div class="subject-management-actions">
          <button
            type="button"
            class="btn subject-management-action-button"
            [attr.aria-label]="isSubjectManagementViewOnly ? 'ดูรายละเอียดรายวิชา' : 'แก้ไขรายวิชา'"
            (click)="onEditSubject(row)"
          >
            <img
              [src]="isSubjectManagementViewOnly ? 'assets/media/icons/svg/eye.svg' : 'assets/media/icons/svg/pencxil.svg'"
              class="subject-management-action-icon"
              [class.datatable-view-action-icon]="isSubjectManagementViewOnly"
              alt=""
              aria-hidden="true"
            />
          </button>
        </div>
      </ng-template>

      <app-datatable
        [datasource]="datasource()"
        [columns]="columns"
        [isLoading]="tableLoading()"
        [limit]="10"
        [showOrder]="false"
        (sortChange)="onSortChange($event)"
      ></app-datatable>

      <app-table-pagination
        [page]="datasource().page"
        [limit]="datasource().limit"
        [total]="datasource().total"
        [totalPage]="datasource().total_page"
        [offset]="datasource().offset"
        [dataLength]="datasource().data.length"
        [isLoading]="tableLoading()"
        [pageSizeOptions]="pageSizeOptions"
        ariaLabel="subject management pagination"
        (pageChange)="onPageChange($event)"
        (limitChange)="onLimitChange($event)"
      ></app-table-pagination>
    </div>
  </div>
</div>

<app-form-import-new
  *ngIf="!isSubjectManagementViewOnly"
  [modalId]="importModalId"
  [isSaving]="isImporting"
  (saved)="onImportFile($event)"
></app-form-import-new>
